import { isSafeNumber, parse } from "lossless-json";

export function trimNumberTrailingZeros(value) {
	const exponentIndex = value.search(/[eE]/);
	const decimalPart = exponentIndex === -1 ? value : value.substring(0, exponentIndex);
	const exponentPart = exponentIndex === -1 ? "" : value.substring(exponentIndex);

	if (!decimalPart.includes(".")) {
		return value;
	}

	return decimalPart.replace(/0+$/, "").replace(/\.$/, "") + exponentPart;
}

function parseNumber(value) {
	const normalizedValue = trimNumberTrailingZeros(value);
	return isSafeNumber(normalizedValue) ? Number(normalizedValue) : normalizedValue;
}

export function parseLosslessJson(value) {
	return parse(value, null, {
		parseNumber,
		// Keep the same duplicate-key behavior as JSON.parse: the last value wins.
		onDuplicateKey: function({ newValue }) {
			return newValue;
		}
	});
}
